import { prefixerI } from '.'

export const ROUTE_REPORTE_STATUS = prefixerI('reporte-status')
export const ROUTE_ARCHIVO_BANCOS = prefixerI('archivo-bancos')
export const ROUTE_LIBRO_BANCOS = prefixerI('libro-bancos')
export const ROUTE_MOVIMIENTOS_BANCARIOS = prefixerI('movimientos-bancarios')

/**
 * PANTALLA PARA GENERAR EL EXCEL DE REPORTE DE PAGOS
 */
export const ROUTE_REPORTE_PAGOS = prefixerI('reporte-pagos')
